export const availableFields = [
  {field: 'scrapedProfile.full_text', display: 'Search in all Fields', desc:'Search in all the fields available'},
  {field: 'scrapedProfile.summary.location', display: 'Location', desc: 'Current living area'},
  // {field: 'scrapedProfile.summary.currentCompany', display: 'Current company'},
  {field: 'scrapedProfile.summary.currentJob', display: 'Current position', desc: 'Name of the current company'},
  {field: 'edges.times.timeInCompany', display: 'Years in current company', desc: 'Years working in the current company'},
  {field: 'edges.times.timeWithoutPromoting', display: 'Years since last promotion', desc: 'Years since last promotion in the current company'},
  {field: 'edges.times.timeInCurrentPosition', display: 'Total experience in current position', desc: 'Years of experience of the current job prosition'},
  {field: 'scrapedProfile.education', display: 'Education', desc: 'Search in all the education experience (titles and universities)'},
  {field: 'scrapedProfile.summary.description', display: 'Personal Description', desc: 'Search in the personal description'},
  // {field: 'scrapedProfile.summary.currentJob', display: 'Current job'},
  {field: 'scrapedProfile.jobs.company.name', display: 'All Companies', desc: 'Search in all the companies where the user has worked (current and former)'},
  {field: 'scrapedProfile.groups.name', display: 'Groups of interest', desc: 'Search in all the groups of interest that the user is following'},
  {field: 'edges.times.totalTimeWorking', display: 'Working experience', desc: 'Total working experience (addition of all jobs)'},
  {field: 'edges.times.avgTimeWorkingCompanies', display: 'Average years in the same company', desc: 'Average years the user works for a company '},
  {field: 'scrapedProfile.languages.language', display: 'Languages', desc: 'Filter by languages spoken by the user'},
  {field: 'scrapedProfile.summary.name', display: 'Name', desc: 'Filter by the name and surname of the user'},
  {field: 'externalId', display: 'External ID', desc: 'Filter by the ID of your CRM'}
];

export const operations = [
  {field: '$and', display: 'Must'},
  {field: '$ne', display: 'Must NOT'},
];

export const scrapedProfileSections = [
  {section: 'summary', colorFill: '#009688', colorLine: '#007866', textColor: '#fff'},
  {section: 'activities', colorFill: '#f44336', colorLine: '#e43327', textColor: '#fff'},
  {section: 'jobs', colorFill: '#3f51b5', colorLine: '#2f3195', textColor: '#fff'},
  {section: 'education', colorFill: '#de6185', colorLine: '#cd5066', textColor: '#fff'},
  {section: 'certifications', colorFill: '#33b678', colorLine: '#22a466', textColor: '#fff'},
  {section: 'publications', colorFill: '#ff9800', colorLine: '#e38000', textColor: '#333'},
  {section: 'languages', colorFill: '#ffd000', colorLine: '#ffc044', textColor: '#333'},
  {section: 'volunteering', colorFill: '#ffd099', colorLine: '#e3c080', textColor: '#333'},
  {section: 'projects', colorFill: '#bddb66', colorLine: '#accc22', textColor: '#333'},
  {section: 'awards', colorFill: '#9c27b0', colorLine: '#7f20a0', textColor: '#fff'},
  {section: 'groups', colorFill: '#ff5722', colorLine: '#ee4711', textColor: '#fff'},
  {section: 'organizations', colorFill: '#607d8b', colorLine: '#505f6b', textColor: '#fff'},
  {section: 'recommendations', colorFill: '#03a9f4', colorLine: '#0099e0', textColor: '#fff'},
  {section: 'patents', colorFill: '#739278', colorLine: '#608065', textColor: '#fff'},
  {section: 'scores', colorFill: '#66aa33', colorLine: '#55a027', textColor: '#fff'},
  {section: 'courses', colorFill: '#6645bb', colorLine: '#5040ab', textColor: '#fff'},
];

export const jobOffersColors = [
  'rgb(0,150,136,0.5)',
  'rgb(244,67,54,0.5)',
  'rgb(63,81,181,0.5)',
  'rgb(222,97,133,0.5)',
  'rgb(51,182,120,0.5)',
  'rgb(255,152,0,0.5)',
  'rgb(255,208,0,0.5)',
  'rgb(255,208,153,0.5)',
  'rgb(189,219,102,0.5)',
  'rgb(156,39,176,0.5)',
  'rgb(255,87,34,0.5)',
  'rgb(96,125,139,0.5)',
  'rgb(3,169,244,0.5)',
  'rgb(115,146,120,0.5)',
  'rgb(102,170,51,0.5)',
  'rgb(102,69,187,0.5)',
];

export const salariesColors = [
  {colorFill: 'rgba(3,169,244,0.8)', colorLine: '#0099e0', textColor: '#fff'},
  {colorFill: 'rgba(244,67,54,0.2)', colorLine: '#e43327', textColor: '#fff'},
  {colorFill: 'rgba(68,252,74,0.2)', colorLine: '#0fe400', textColor: '#fff'}
]

export const salaryDataStructure = {
  from: new Date().toISOString().substr(0, 10),
  to: null,
  baseSalaryRange: {
    min: 0,
    max: null
  },
  salaryCurrency: 'EUR',
  bonusSalaryRange: {
    min: 0,
    max: null,
  },
  perks: null,
  estimatedPerksValue: 0
};
export const salaryRanges = [
  {min: 0, max: 20000},
  {min: 20000, max: 25000},
  {min: 25000, max: 30000},
  {min: 30000, max: 40000},
  {min: 40000, max: 50000},
  {min: 50000, max: 60000},
  {min: 50000, max: 60000},
  {min: 60000, max: 70000},
  {min: 70000, max: 90000},
  {min: 90000, max: 110000},
  {min: 110000, max: null},
];
export const bonusRanges = [
  {min: 0, max: 2000},
  {min: 2000, max: 4000},
  {min: 4000, max: 7000},
  {min: 7000, max: 10000},
  {min: 10000, max: 15000},
  {min: 15000, max: null},
];
export const currencies = ['EUR', 'USD', 'GBP'];
export const perks = [
  {display: 'Personal development', tooltip: 'Budget for conferences, courses, education...'},
  {
    display: 'Wellness',
    tooltip: 'Whatever you pay for the worker in order to be physical and mentally fit, like Gym, Physio, Psychologist,'
  },
  {display: 'Transportation', tooltip: 'Budget for parking, motorbike renting, bike...'},
  {display: 'Free food&drinks', tooltip: 'Snacks, fresh fruit, coffee & tea... everything for free'},
  {display: 'Flexibility', tooltip: 'If you allow flexible working times, work from home, doctor visits...'}
];
export const formFields = {
  name: '',
  urlProvided: '',
  status: 'active',
  jobSearchTerms: [{
    term: '',
    shifting: null,
    jobKeywordName: '',
    jobKeywordCity: '',
    jobKeywordId: null,
    yearsExperience: null,
    experienceSince: null,
    allowEditExperienceSince: false
  }],
  salary: [
    salaryDataStructure
  ],
  employeeLeavingReasons: []
};
export const UPGRADE = 'upgrade';
export const PIVOTAL = 'pivotal';
export const maxSimilarPositions = 3;

export const icevergPlans = {
  conditions: [
    'Weekly update of all your profiles',
    'Access to the data 24x7',
    'Weekly notifications of your profiles\' activity',
    '2 free months when buying the annual plan',
    'For bigger plans, contact us!'
  ],
  plans: [
    // {
    //   id: 0,
    //   name: 'Trial',
    //   maxProfiles: 20,
    //   maxDays: 30,
    //   pricePerMonth: 0,
    //   pricePerYear: 0,
    //   currency: '€',
    //   class: 'deep-purple lighten-4',
    //   btnClass: 'deep-purple darken-2',
    // },
    // {
    //   id: 1,
    //   name: 'Lite',
    //   maxProfiles: 20,
    //   pricePerMonth: 39.90,
    //   pricePerYear: 399,
    //   currency: 'EUR',
    //   class: 'deep-purple lighten-4',
    //   btnClass: 'deep-purple darken-2',
    // },
    // {
    //   id: 2,
    //   name: 'Plus',
    //   maxProfiles: 50,
    //   pricePerMonth: 59.90,
    //   pricePerYear: 599,
    //   currency: '€',
    //   class: 'indigo lighten-4',
    //   btnClass: 'indigo darken-2',
    //
    // },
    {
      id: 3,
      name: 'Premium',
      maxProfiles: 100,
      pricePerMonth: 99.90,
      pricePerYear: 999,
      currency: '€',
      class: 'teal lighten-4',
      btnClass: 'teal darken-2',

    }, {
      id: 4,
      name: 'Pro',
      maxProfiles: 400,
      pricePerMonth: 199.90,
      pricePerYear: 1999,
      currency: '€',
      class: 'green lighten-4',
      btnClass: 'green darken-2',

    }, {
      id: 5,
      name: 'Corpo',
      maxProfiles: 1000,
      pricePerMonth: 349.90,
      pricePerYear: 3499,
      currency: '€',
      class: 'blue-grey lighten-4',
      btnClass: 'blue-grey darken-2'
    }, {
      id: 6,
      name: 'TOP',
      maxProfiles: 5000,
      pricePerMonth: 999.90,
      pricePerYear: 9999,
      currency: '€',
      class: 'grey darken-1',
      btnClass: 'grey darken-3'
    }, {
      id: -1,
      name: '&infin;',
      maxProfiles: '&infin;',
      pricePerMonth: undefined,
      pricePerYear: undefined,
      currency: '€',
      class: 'blue lighten-2',
      btnClass: 'blue darken-3'
    }
  ]
}

export const employeeLeavingReasons = [
  {
    reasonId: 1, reasonText: 'The employee was fired'
  },
  {
    reasonId: 2, reasonText: 'The employee contract expired and the company refused to extend it'
  },
  {
    reasonId: 3,
    reasonText: 'The employee moved to another company',
    children: [
      {
        reasonId: 30, reasonText: 'Better salary',
        children: [
          {
            reasonId: 300, reasonText: '5K More'
          },
          {
            reasonId: 301, reasonText: '10K More'
          },
          {
            reasonId: 302, reasonText: '15K More'
          },
        ]
      },
      {
        reasonId: 31, reasonText: 'More flexibility',
      },
      {
        reasonId: 32, reasonText: 'Better career opportunities',
      },
      {
        reasonId: 33, reasonText: 'Less pressure at work',
      },
      {
        reasonId: 34, reasonText: 'Better life/work conciliation',
      },
      {
        reasonId: 35, reasonText: 'New challenge',
      },
      {
        reasonId: 36, reasonText: 'Felt undervalued',
      },
      {
        reasonId: 37, reasonText: 'The employee decided to take time off',
        children: [
          {
            reasonId: 370, reasonText: 'Study',
          },{
            reasonId: 371, reasonText: 'Medical Reasons',
          },{
            reasonId: 372, reasonText: 'Family Reasons',
          },
        ]
      }
    ]
  }
]





// WEBPACK FOOTER //
// ./src/constants/constants.js